import { Menu, MenuProps } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// import { setUserItem } from "@/stores/user.store";

// import { CustomIcon } from "./customIcon";

const MenuComponent = (props) => {
  const {
    menuList,
    openKey,
    onChangeOpenKey,
    selectedKey,
    onChangeSelectedKey,
  } = props;
  //   const { device, locale } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onMenuClick = (path) => {
    onChangeSelectedKey(path);
    navigate(path);

    // if (device !== "DESKTOP") {
    //   dispatch(setUserItem({ collapsed: true }));
    // }
  };

  const onOpenChange = (keys) => {
    const key = keys.pop();

    onChangeOpenKey(key);
  };

  return (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      openKeys={openKey ? [openKey] : []}
      onOpenChange={onOpenChange}
      onSelect={(k) => onMenuClick(k.key)}
      className="layout-page-sider-menu text-2"
      items={menuList}
      style={{ height: "100%" }}
    ></Menu>
  );
};

export default MenuComponent;
